import store from "../../../store";
import google_food_export from './google_food_export.vue';

window.bolt_retail_export =  new Vue({
    store,
    el: 'div#google-food_export',

    name : "google_food_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        google_food_export,
    }
});
